import * as React from 'react';

import { Box, Skeleton } from '@mui/material';
import { Sizes } from '../../@shared/palette';
import { FlexBoxInline } from '../../@shared/templates';


const ModalShimmer = () => {

  return <Box sx={{ padding: "15px", width: "100%" }}>
    <Skeleton variant="text" width={250} sx={{ fontSize: Sizes.pageTitle, marginBottom: "5px" }} />
    <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "10px" }} />
    <Skeleton variant="text" width={350} sx={{ fontSize: Sizes.textSecondary, marginBottom: "20px" }} />
    <Box sx={{ ...FlexBoxInline, marginBottom: "20px" }}>
      <Skeleton variant="rectangular" width={50} height={20} />
      <Skeleton variant="rectangular" width={60} height={20} />
      <Skeleton variant="rectangular" width={70} height={20} />
      <Skeleton variant="rectangular" width={20} height={20} />
    </Box>
    <Box sx={{ ...FlexBoxInline, marginBottom: "20px", gap: 0 }}>
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
      <Skeleton variant="rectangular" width={100} height={50} />
    </Box>


    <Box sx={{ ...FlexBoxInline, marginBottom: "5px" }}>
      <Skeleton variant="text" width={130} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={300} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    </Box>
    <Box sx={{ ...FlexBoxInline, marginBottom: "5px" }}>
      <Skeleton variant="text" width={130} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={300} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    </Box>
    <Box sx={{ ...FlexBoxInline, marginBottom: "5px" }}>
      <Skeleton variant="text" width={130} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={300} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
    </Box>
  </Box>


}

export default ModalShimmer;
